<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="510px">

<v-card>
  <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
  <v-divider></v-divider>
  <v-card-text>

    <v-card flat="" class="white--text">
      <v-card flat="">
        <v-card-actions>
          <v-layout row="" wrap="">
           <v-flex xs12 sm12 md12>
            <v-select
  label="İstenen Gruplar"
  :items="IncludeAccountGroups"
  v-model="searchParams.IncludeAccountGroupList"
  multiple
></v-select>
          </v-flex>
          <v-flex xs12 sm12 md12>
            <v-select
  label="İstenmeyen Gruplar"
  :items="ExcludeAccountGroups"
  v-model="searchParams.ExcludeAccountGroupList"
  multiple
></v-select>
          </v-flex>
            <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="accoutingCode"
                    :controlValue="accoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('Start-Accounting-Code')"
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="endAccoutingCode"
                    :controlValue="endAccoutingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    :text="$t('End-Accounting-Code')"
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
              <v-checkbox v-model=searchParams.ExcludeClosingFiche
      label="Kapanış Fişini Dahil Etme" false-value="0"
    true-value="1"
    ></v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-card-text>
  <v-divider></v-divider>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{ $t('cancel_button') }} </v-btn>
    <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
  </v-card-actions>
</v-card>


</v-dialog>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-toolbar size="120px" dark color="info">
            <v-toolbar-title>Borç Yaşlandırma Raporu</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-text-field
              flat=""
              solo-inverted=""
              hide-details
              v-model="search"
              :label="$t('Search')"
              append-icon="search"
            >
            </v-text-field>

            <v-menu offset-y>
              <v-btn slot="activator" dark icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="getListHtml()">
                  <v-list-tile-title
                    >Html {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>

                <v-list-tile @click="getListExcel()">
                  <v-list-tile-title
                    >Excel {{ $t("Download") }}</v-list-tile-title
                  >
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-toolbar>
        </v-flex>
<v-container fluid>
  <v-form ref="muhasebehesabagore" v-model="valid">
              <v-layout row wrap="">
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Date')"
                    v-bind:defaultvalue="'ok'"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-model="searchParams.Date"
                    v-bind:value="searchParams.Date"
                  ></tarihcomp>
                </v-flex>

             

               
               
                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                                            <v-btn color="info" @click="getList()" fab small="" dark>

                                                <v-icon>search</v-icon>
                                            </v-btn>
                                        </div>
                                        <div v-if="!load1">
                                            <v-layout fill-height="" align-center="">
                                                <v-progress-circular indeterminate color="primary">
                                                </v-progress-circular>
                                            </v-layout>
                                        </div>

                    <v-btn small="" @click="filtrele()" color="info" fab dark>
                      <v-icon>filter_list</v-icon>
                    </v-btn>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-form>
</v-container>
       

        <v-container fluid="">
          <v-card color="grey lighten-5" flat>
           
            <v-layout>
              <v-flex xs12 sm12 md12 pt-2>
                <v-card flat>
                  <v-data-table
                    :headers="headers"
                    class="elevation-1"
                    :rows-per-page-items="[50, 100, 250, 500]"
                    :items="items"
                    :search="search"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-left">
                        {{ props.item.Code  }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.CodeName  }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Gelmeyen | moneyformat }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Sifiryedi | moneyformat }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Sekizondort | moneyformat }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Onbesyirmibir | moneyformat  }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Yirmiikiotuz | moneyformat  }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Otuzbirkirkbes | moneyformat  }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Kirkaltialtmis | moneyformat  }}
                      </td>
                      <td class="text-xs-left">
                        {{ props.item.Altmisustu | moneyformat }}
                      </td>
                      <td class="text-xs-right">
                        {{ props.item.Toplam | moneyformat }}
                      </td>
                    
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-container>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import tarihcomp from "../../customcomp/tarihim";
import auth from "../../../../api/auth";
import catimuhasebekodu from "../comp/catimuhasebekodu.vue";

export default {
  data() {
    return {
      load1: true,
    dovizTipleri:[
    {
          text: "TL",
          value:0
     },
     {
          text: "Döviz",
          value:1
     },
     {
          text: "Döviz + TL",
          value:3
     },
    ],
      dialogfiltre:false,
      search: null,
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      valid: true,
      searchParams: {
        CompanyID: 0,
        Date: null,
        FirstAccountCode: null,
        EndAccountCode: null,
        IncludeAccountGroupList :[],
        ExcludeAccountGroupList:[],
        ExcludeClosingFiche:0
      },
      IncludeAccountGroups:[],
      ExcludeAccountGroups:[],
      accoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      endAccoutingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      items: [],
      TotalPrices: {
        Gelmeyen: 0.0,
        Sifiryedi: 0.0,
        Sekizondort: 0.0,
        Onbesyirmibir: 0.0,
        Yirmiikiotuz: 0.0,
        Otuzbirkirkbes: 0.0,
        Kirkaltialtmis: 0.0,
        Altmisustu: 0.0,
        Toplam: 0.0
    },
      headers: [
        {
          text: "Hesap No",
        },
        {
          text: "Hesap Adı",
        },
        {
          text: "Gelmeyen",
        },
        {
          text: "0-7",
        },
        {
          text: "8-14",
        },
        {
          text: "15-21",
        },
        {
          text: "22-30",
        },
        {
          text: "31-45",
        },
        {
          text: "46-60",
        },
        {
          text: "60=>",
        },
        {
          text: this.$t("Total"),
          align: "right",
        },
       
      ],
    };
  },
  methods: {
    filtrekayit()
    {
      this.dialogfiltre=false;
      this.getList();
    },
    filtreiptal()
    {
      this.dialogfiltre=false;
    },
    filtrele()
    {
      this.dialogfiltre=true;
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
 
    getparabirimi() {
      return helpers.getparabirimi();
    },
    getAccountsGroups() {
      var params = {};
      let muhasebePrms= {
        CompanyID  : this.credentials.MuhasebeSirketNo
        }
        params=muhasebePrms;
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingCodes/AccountGroupList",
          params,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            this.ExcludeAccountGroups = response.body;
            this.IncludeAccountGroups=response.body;
            this.loadingvmodel = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    getList() {
      this.load1=false;
          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
          this.searchParams.FirstAccountCode = this.accoutingCode.Code;
          this.searchParams.EndAccountCode = this.endAccoutingCode.Code;

      
          this.items = [];
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/DebitAgingReport",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {

                let totalRow = {}; 
                totalRow.Code = " ";
                totalRow.CodeName = "Genel Toplam:";
             
                totalRow.Gelmeyen = response.body.TotalPrices.Gelmeyen;
                totalRow.Sifiryedi = response.body.TotalPrices.Sifiryedi;;
                totalRow.Sekizondort = response.body.TotalPrices.Sekizondort;;
                totalRow.Onbesyirmibir = response.body.TotalPrices.Onbesyirmibir;;
                totalRow.Yirmiikiotuz = response.body.TotalPrices.Yirmiikiotuz;;
                totalRow.Otuzbirkirkbes = response.body.TotalPrices.Otuzbirkirkbes;;
                totalRow.Kirkaltialtmis = response.body.TotalPrices.Kirkaltialtmis;;
                totalRow.Altmisustu = response.body.TotalPrices.Altmisustu;
                totalRow.Toplam = response.body.TotalPrices.Toplam;
                this.items.push(totalRow);
               
                this.TotalPrices=response.body.TotalPrices;

                response.body.Details.forEach((element) => {
                  this.items.push(
                        {
                          Code:element.AccountingCode.Code ,
                          CodeName:element.AccountingCode.CodeName,
                          Gelmeyen:element.Gelmeyen,
                          Sifiryedi: element.Sifiryedi,
                          Sekizondort:element.Sekizondort,
                          Onbesyirmibir:element.Onbesyirmibir,
                          Yirmiikiotuz:element.Yirmiikiotuz,
                          Otuzbirkirkbes: element.Otuzbirkirkbes,
                          Kirkaltialtmis:element.Kirkaltialtmis,
                          Altmisustu:element.Altmisustu,
                          Toplam:element.Toplam

                        });
                })
              
              
                this.load1=true;
                
              },
              (response) => {
                if (response.status === 0) {
                  this.load1=true;
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.load1=true;
                  this.text1 = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        
     
    },
   
    getListHtml() {
     
     
        
       
       
         
          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
          this.searchParams.FirstAccountCode = this.accoutingCode.Code;
          this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
         

          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/DebitAgingReportHtml",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/html",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "BorcYaslandirma.html";
                link.click();
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        
     
    },
    getListExcel() {
     
      
       
      
       
          
          this.searchParams.CompanyID = this.credentials.MuhasebeSirketNo;
          this.searchParams.FirstAccountCode = this.accoutingCode.Code;
          this.searchParams.EndAccountCode = this.endAccoutingCode.Code;
        
          this.$http
            .post(
              auth.API_URL + "api/AccountingReports/DebitAgingReportExcel",
              this.searchParams,
              {
                headers: {
                  Authorization: "Bearer " + auth.getAuthHeader(),
                },
                responseType: "arraybuffer",
              }
            )
            .then(
              (response) => {
                var blob = new Blob([response.data], {
                  type: "application/xlsx",
                });
                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = "BorcYaslandirma.xlsx";
                link.click();
              },
              (response) => {
                if (response.status === 0) {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                } else {
                  this.text = "Service Unavailable";
                  this.snackbar = true;
                }
              }
            );
        
    
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    tarihcomp,
    catimuhasebekodu,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);

    this.getAccountsGroups();
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;

    //           window.open(url, "_self");
    //         } else {
    //           var mainUrl = "#/";
    //           window.open(mainUrl, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

